import React, { useState } from 'react';
import { motion } from 'framer-motion';
const MOODS = ['Dark & Psychological', 'Feel-Good', 'Action-Packed', 'Romance', 'Mind-Bending'];
export function Hero() {
  const [activeMood, setActiveMood] = useState('Dark & Psychological');
  return <section className="pt-12 pb-8" data-id="element-38">
      <div className="max-w-3xl" data-id="element-39">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-rose-500 text-sm font-medium tracking-widest uppercase mb-4 flex items-center gap-2" data-id="element-40">
          <span className="w-2 h-2 rounded-full bg-rose-500 animate-pulse-slow" data-id="element-41" />
          AI Curated For You
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-5xl md:text-7xl font-serif leading-[1.1] mb-8 text-white/90" data-id="element-42">
          What are you in the mood for tonight?
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap gap-3" data-id="element-43">
          {MOODS.map(mood => {
          const isActive = activeMood === mood;
          return <button key={mood} onClick={() => setActiveMood(mood)} className={`relative px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 ${isActive ? 'text-white' : 'text-white/50 hover:text-white/80 bg-white/5 hover:bg-white/10'}`} data-id="element-44">
                {isActive && <motion.div layoutId="activeMood" className="absolute inset-0 bg-rose-500/20 border border-rose-500/50 rounded-full shadow-[0_0_15px_rgba(244,63,94,0.3)]" transition={{
              type: 'spring',
              bounce: 0.2,
              duration: 0.6
            }} data-id="element-45" />}
                <span className="relative z-10" data-id="element-46">{mood}</span>
              </button>;
        })}
        </motion.div>
      </div>
    </section>;
}